import { defineReceiver } from '@drapejs/invoker';
import { isNode } from '@drapejs/runtime-context';
import { request, query, sales } from '@distancify/drapejs-litium';
import { fetchPage } from '@drapejs/core';
import { gql } from 'graphql-request';
import { userFields } from '@/connectors/user';

const reportCheckoutLoaded = defineReceiver(
  fetchPage,
  async function (command, data) {
    const result = await request(
      this.cache,
      query(
        gql`
          mutation reportCheckoutLoaded($url: String) {
            session(url: $url) {
              reportCheckoutLoaded {
                error
                cart {
                  ...CartFields
                }
                user {
                  ...UserFields
                }
              }
            }
          }
          ${userFields}
        `,
        ...sales.withCartFields()
      ),
      {
        url: `${(<any>command).protocol}//${(<any>command).host}${
          (<any>command).path
        }`,
      }
    );

    const { cart } = result.session.reportCheckoutLoaded;
    if (cart) {
      await this.cache.setItem('__cart', cart);
    }

    return data;
  },
  'litium'
);

export const scheduleRefreshCartReceiver = defineReceiver(
  fetchPage,
  async function (command: any, data) {
    if (isNode()) {
      return data;
    }

    if (isCheckoutPage(data)) {
      await reportCheckoutLoaded.call(this, command, data);
      return data;
    } else {
      await sales.scheduleRefreshCartReceiver.call(this, command, data);
      return data;
    }
  }
);

function isCheckoutPage(data: any) {
  const component = data?.component?.toLowerCase();
  return component && component.indexOf('checkout') >= 0;
}
